import { useState } from 'react';
import { Vetlogin } from '../components/vetlogin2.2v1/vetlogin.module';
import { encryptFunction } from '../components/popencrypt2.2v1/encryptfunction';
//import { APP_PLATFORM_ID } from '../constants/data';
import { loginApi } from '../services/loginService';
import { getSessionId, getUserId } from '../services/tokenService';
import Loading from 'react-fullscreen-loading';
import { navigateTo } from '../services/navigationService';
import { generateDataStringObject, poDetailApi } from '../services/poApiService';
import { fetchCountryCode } from '../services/locationService';

export const VetLoginMod = () => {


    const [showLoader, setShowLoader] = useState(false);
    var part2 = fetchCountryCode();
    var appid = 'QOL_POP_' + sessionStorage.getItem('country_code');

    if (!sessionStorage.getItem('APP_PLATFORM_ID')) {
        sessionStorage.setItem('APP_PLATFORM_ID', appid);
    }
    const APP_PLATFORM_ID = sessionStorage.getItem('APP_PLATFORM_ID');

    const loginCallback = async (payload) => {
        setShowLoader(true);

       

        payload.APP_PLATFORM_ID = APP_PLATFORM_ID;

        const auth_string = encryptFunction(payload);
        const data_string = encryptFunction({
            MODULE_NAME :'petownerlogin', 
            SESSION_ID: getSessionId(),
            USER_ID: getUserId(),
            DATA_JSON: '',
          });

        const resp = await loginApi(auth_string, data_string);
        console.log(resp);

        if(resp?.data?.RESPONSE_STATUS_CD === 'S') {
            sessionStorage.setItem('APP_VET_ID', resp.data.DATA.APP_VET_ID);
            navigateTo('/vetdashboard.html');
        } else {
            alert(resp?.data?.RESPONSE_DESCRIPTION);
        }
        setShowLoader(false);
    }

    return (
        <>
           <Vetlogin loginCallback={loginCallback} />
           {showLoader ? <Loading loading background="rgba(0,0,0,.5)" loaderColor="#3498db" /> : ''}
        </>
    )
}